export const sceneNumbers = {
	initMainMenu: 0,
	initIntroduction: 1,
	team1SubtopicOne: 2,
	team1SubtopicTwo: 3,
	team1SubtopicThree: 4,
	team1SubtopicFour: 5,
	team1SubtopicFive: 6,
	team1SubtopicSix: 7,
	team1SubtopicSeven: 8,
};
